export default {
  header: 'Einmaliges Teil erstellen',
  subHeader: 'Erstellen Sie ein einmaliges Teil für Ihren Qualitätsbericht',
};
